module.exports = __webpack_public_path__ + "img/logo-zh.fc64c2df.png";